module.exports = __webpack_public_path__ + "media/8.000b9e04.mp3";